import React, { useEffect } from "react";
import Select from "react-select";

export default function CreateModal({
  handleSubmit,
  onSubmit,
  fields,
  register,
  errors,
  isEdit,
  edit,
  getValues,
  setValue,
  watch,
  reset,
  Controller,
  control,
}) {
  const onChange = watch();
  useEffect(() => {
    if (isEdit) {
      for (const key in edit) {
        if (edit.hasOwnProperty(key)) {
          setValue(key, edit[key]);
        }
      }
    } else {
      reset("");
    }
  }, [edit, setValue, isEdit]);
  const value = getValues();

  const watchValue = watch();
  return (
    <div
      class="modal fade"
      id="createApiModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header text-center">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                {isEdit ? "CHỈNH SỬA API" : "THÊM API"}
              </h1>
            </div>
            <div className="modal-body">
              {fields.map((field) => {
                const defaultVal = isEdit
                  ? value?.[field.register]
                  : watchValue[field.register];

                return (
                  <div key={field.id} className="form-group">
                    <div className="row mb-3">
                      <label
                        htmlFor={field.id}
                        className="col-sm-2 col-form-label"
                      >
                        {field.label}
                      </label>
                      <div
                        className={`col-sm-${
                          field.type === "select" ||
                          field.type === "datetime-local" ||
                          field.type === "time"
                            ? "4"
                            : "10"
                        }`}
                      >
                        {/* SELECT FIELD */}
                        {field.type === "select" ? (
                          <Controller
                            control={control}
                            name={field.register}
                            rules={field.validation}
                            defaultValue={
                              field.options?.find(
                                (option) =>
                                  option.value === defaultVal?.value ||
                                  defaultVal
                              ) || null
                            }
                            render={({ field: controllerField }) => (
                              <Select
                                {...controllerField}
                                inputId={field.id}
                                options={field.options?.map((option) => ({
                                  label: option.label,
                                  value: option.value,
                                  isDisabled: option?.disabled,
                                }))}
                                value={
                                  defaultVal?.label
                                    ? defaultVal
                                    : {
                                        label:
                                          field.options?.find(
                                            (option) =>
                                              option.value === defaultVal
                                          )?.label || "",
                                        value: defaultVal || "",
                                      }
                                }
                                onChange={(selectedOption) => {
                                  controllerField.onChange(selectedOption);
                                }}
                              />
                            )}
                          />
                        ) : field.type === "textarea" ? (
                          <textarea
                            className="form-control"
                            id={field.id}
                            rows={4}
                            {...register(field.register, field.validation)}
                            defaultValue={defaultVal}
                          ></textarea>
                        ) : field.type === "groups" ? (
                          <div className="row">
                            {field.groups.map((groupField) => {
                              const ms = value?.[field.register] || 0;
                              const days = Math.floor(
                                ms / (1000 * 60 * 60 * 24)
                              );
                              const hours = Math.floor(
                                (ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                              );
                              const minutes = Math.floor(
                                (ms % (1000 * 60 * 60)) / (1000 * 60)
                              );

                              const repeatTimeMinutes = {
                                days,
                                hours,
                                minutes,
                              };

                              return (
                                <div
                                  key={groupField.id}
                                  className={
                                    groupField.col ? groupField.col : "col-sm-4"
                                  }
                                >
                                  <label htmlFor={groupField.id}>
                                    {groupField.label}
                                  </label>

                                  <select
                                    id={groupField.id}
                                    className="form-control"
                                    {...register(
                                      `${field.register}.${groupField.register}`,
                                      groupField.validation
                                    )}
                                    defaultValue={
                                      repeatTimeMinutes[groupField.register]
                                    }
                                  >
                                    {groupField.options?.map((option) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ))}
                                  </select>

                                  {errors?.[groupField.register] && (
                                    <p className="text-danger">
                                      {errors[groupField.register]?.message}
                                    </p>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <input
                            className="form-control"
                            id={field.id}
                            type={field.type}
                            {...register(field.register, field.validation)}
                            defaultValue={defaultVal}
                          />
                        )}

                        {errors?.[field.register] &&
                          field.type !== "groups" && (
                            <p className="text-danger">
                              {errors[field.register]?.message}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Đóng
              </button>
              <button type="submit" class="btn btn-primary">
                {isEdit ? "Cập Nhật" : "Thêm"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
